module.exports = __webpack_public_path__ + "img/newLogoSide2.635dd0ec.png";